export enum RefreshedDateKey {
  MasterSerach = 'MASTER_SEARCH_LAST_DATA_REFRESH_DATE',
  DPNF = 'DPNF_ENTRY_START_DATE',
  Defaulter = 'DEFAULTER_LAST_DATA_REFRESH_DATE',
  OblateRegister = 'OBLATE_REGISTER_LAST_DATA_REFRESH_DATE',
  AllReport = 'ALL_REPORT_REFRESH_DATE',
  DSPCountries = 'DSP_RECV_COUNTRIES',
  PhilReport = 'PHIL_REPORT_REFRESH_DATE',
  wishlistItems = 'STAGNANT_WISHLIST_LAST_DATA_REFRESH_DATE',
  panjaRenawalSlot = 'WORKER_PANJA_RECEIVE_SLOT',
  defaulterDynamicReportDate = 'DEFAULTER_DYNAMICS_START_DATE'
}
